/*
 * @Descripttion: 任务详情页State
 * @Author: 曹博
 * @Date: 2023-12-08 09:48:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 10:26:23
 */
import { ActionType, CustomAction } from '../../global'

export interface HeaderParam {
  taskResult: string
  taskResultType: string
  taskResultState: string
}

// 当前状态接口
export interface TaskDetailState {
  dataSource: { data: any[]; total: number }
  dataSourceLoading: boolean
  taskId: string
  pages: {
    pageNo: number
    pageSize: number
  }
  headertitle: HeaderParam
  file: {
    fileUrl: string
    fileName: string
  }
}

// 默认数据
export const defaultState: TaskDetailState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100 },
  dataSourceLoading: true,
  taskId: '',
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  headertitle: {
    taskResult: '',
    taskResultType: '',
    taskResultState: '',
  },
  file: {
    fileUrl: '',
    fileName: '',
  },
}

type Action = ActionType<TaskDetailState>

// 默认 Reducer
export default function reducer(
  state = defaultState,
  action: CustomAction<Action>,
): TaskDetailState {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload.dataSource
      arr.pages.pageNo = action.payload.pageNo
      return arr
    case 'setPagesAction':
      arr.pages = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    case 'setHeadertitleAction':
      arr.headertitle = action.payload
      return arr
    case 'setTaskIdAction':
      arr.taskId = action.payload
      return arr
    case 'setFileAction':
      arr.file = action.payload
      return arr
    default:
      return state
  }
}

// 设置数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// loading
export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

export const setHeadertitleAction = (
  param: HeaderParam,
): CustomAction<Action> => ({
  type: 'setHeadertitleAction',
  payload: param,
})

export const setTaskIdAction = (param: string): CustomAction<Action> => ({
  type: 'setTaskIdAction',
  payload: param,
})

export const setFileAction = (param: {
  fileUrl: string
  fileName: string
}): CustomAction<Action> => ({
  type: 'setFileAction',
  payload: param,
})

export const reloadStateAction = (
  param: TaskDetailState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
/*
 * @Descripttion: 任务详情页State
 * @Author: 曹博
 * @Date: 2023-12-08 09:48:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 10:26:23
 */
import { ActionType, CustomAction } from '../../global'

export interface HeaderParam {
  taskResult: string
  taskResultType: string
  taskResultState: string
}

// 当前状态接口
export interface TaskDetailState {
  dataSource: { data: any[]; total: number }
  dataSourceLoading: boolean
  taskId: string
  pages: {
    pageNo: number
    pageSize: number
  }
  headertitle: HeaderParam
  file: {
    fileUrl: string
    fileName: string
  }
}

// 默认数据
export const defaultState: TaskDetailState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100 },
  dataSourceLoading: true,
  taskId: '',
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  headertitle: {
    taskResult: '',
    taskResultType: '',
    taskResultState: '',
  },
  file: {
    fileUrl: '',
    fileName: '',
  },
}

type Action = ActionType<TaskDetailState>

// 默认 Reducer
export default function reducer(
  state = defaultState,
  action: CustomAction<Action>,
): TaskDetailState {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload.dataSource
      arr.pages.pageNo = action.payload.pageNo
      return arr
    case 'setPagesAction':
      arr.pages = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    case 'setHeadertitleAction':
      arr.headertitle = action.payload
      return arr
    case 'setTaskIdAction':
      arr.taskId = action.payload
      return arr
    case 'setFileAction':
      arr.file = action.payload
      return arr
    default:
      return state
  }
}

// 设置数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// loading
export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

export const setHeadertitleAction = (
  param: HeaderParam,
): CustomAction<Action> => ({
  type: 'setHeadertitleAction',
  payload: param,
})

export const setTaskIdAction = (param: string): CustomAction<Action> => ({
  type: 'setTaskIdAction',
  payload: param,
})

export const setFileAction = (param: {
  fileUrl: string
  fileName: string
}): CustomAction<Action> => ({
  type: 'setFileAction',
  payload: param,
})

export const reloadStateAction = (
  param: TaskDetailState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
